import { Expose, Transform } from "class-transformer";
import { parseAppDate } from "@/utils/dates/dateFormats";

export class UpdateTechnicianCostsDto {
  @Expose()
  @Transform(({ value }) => parseAppDate(value, false))
  fromDate: Date;

  @Expose()
  userIds?: string[];

  @Expose()
  collectiveAgreementId?: string;
}
